export const getCombinedProjects = (dataForTable: any) => {
    const allDelivered = dataForTable?.data?.allDeliveredProjects || [];
    const allRTD = dataForTable?.data?.allRTDProjects || [];
    const allDraft = dataForTable?.data?.allDraftProjects || [];
    const allProjects = dataForTable?.data?.allProjects || [];
    return [...allDelivered, ...allRTD, ...allDraft, ...allProjects];
};
